module.exports = __webpack_public_path__ + "img/geo-fence.fc4ad178.svg";